var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#BEC4DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19.5C20.0207 19.5 19.3212 19.7897 18.8055 20.3055C18.2897 20.8212 18 21.5207 18 22.25V30.75C18 31.4793 18.2897 32.1788 18.8055 32.6945C19.3212 33.2103 20.0207 33.5 20.75 33.5H35.25C35.9793 33.5 36.6788 33.2103 37.1945 32.6945C37.7103 32.1788 38 31.4793 38 30.75V22.25C38 21.5207 37.7103 20.8212 37.1945 20.3055C36.6788 19.7897 35.9793 19.5 35.25 19.5H20.75ZM19.5 22.25C19.5 21.56 20.06 21 20.75 21H35.25C35.94 21 36.5 21.56 36.5 22.25V30.75C36.5 31.44 35.94 32 35.25 32H20.75C20.06 32 19.5 31.44 19.5 30.75V22.25ZM21.75 35C21.5511 35 21.3603 35.079 21.2197 35.2197C21.079 35.3603 21 35.5511 21 35.75C21 35.9489 21.079 36.1397 21.2197 36.2803C21.3603 36.421 21.5511 36.5 21.75 36.5H34.25C34.4489 36.5 34.6397 36.421 34.7803 36.2803C34.921 36.1397 35 35.9489 35 35.75C35 35.5511 34.921 35.3603 34.7803 35.2197C34.6397 35.079 34.4489 35 34.25 35H21.75Z",
    fill: "#263B95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/cable.6c0431b803e17de8bfe391962092f20c.svg";
export { ForwardRef as ReactComponent };